import _ from "lodash";
import TableReportHelper from "report/helper";

export default function apontamentoImagesReport(visita, indicador, apontamento) {
    if (_.isEmpty(apontamento.images)) {
        return null;
    }

    const h = new TableReportHelper(apontamento);

    const content = [
        h.panel([
            // prettier-ignore
            h.row(
                h.title("Imagens da Amostra")
            ),
        ]),
    ];

    const imagesContent = [
        // prettier-ignore
        h.row(
            h.title("Foto"),
            h.title("Localização"),
            h.title("Descrição"),
        ),
    ];
    if (!apontamento.images) {

        throw new Error("Apontamento deve conter imagem")
    }
    for (const image of apontamento.images) {
        const r = h.helper(image);

        imagesContent.push(
            // prettier-ignore
            h.row(
                r.imageField("base64", { fit: [150, 150], }),
                r.locationField("georeferencia"),
                r.textField("descricao"),
            )
        );
    }

    content.push(h.panel(imagesContent, { widths: [150, 70, "*"] }));

    return content;
}
